import { IYxInputPropTypes, lableIValueItme } from "./basePropType";
import PropTypes from "prop-types";
import { IYxrequest } from "../../../utils/propType";

export const ITreeSelectPropTypes = {
  ...IYxInputPropTypes,

  //用于循环显示下拉列表，必须包含value和labels
  data: PropTypes.arrayOf(lableIValueItme),

  //接口请求参数
  requestParam: IYxrequest,

  //版本号，不一致时重新请求
  version: PropTypes.string,
};

export const treeSelectDefaultProps = () => ({
  requestParam: null,
  styleParam: {
    size: "default", //大小
    type: "default", //类型
    width: "sm", //宽度
  },
  rules: {
    max: "",
  },
  data: [], //用于循环显示下拉列表，必须包含key和label
  version: "", //版本号
  children: "", //子节点
  inputParam: {},
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/treeSelectPropType.js